module.exports = __webpack_public_path__ + "img/bg_wheat.b2f74062.jpg";